import eventBus from "../service/eventBus";
import {ModalEvents} from "../components/style-guide/modal/ModalEvents";

export const ModalHelper = class {
  static open(title, content, onClose, props = {}) {
    eventBus.dispatch(ModalEvents.OPEN, {content, title, onClose, ...props});
  }

  static close() {
    eventBus.dispatch(ModalEvents.CLOSE);
  }
};
